module.exports = __webpack_public_path__ + "static/media/fiji.60678e66.webp";